module.exports = __webpack_public_path__ + "static/media/nevada.ad94be9a.md";